import React, { useState } from 'react';
import { Table, TableBody, TableHead, Paper, TextField, TableRow, TableCell, IconButton, Button, Tooltip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import EditIcon from '@material-ui/icons/Edit';
import { useSnackbar } from 'notistack';
import { withRouter } from 'react-router'
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { gtalable_dropdownField } from '.';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { globalDeleteService } from '../../../utils_v2/globalApiServices';
import { checkApiStatus, onCheckFormPermission } from '../../../utils_v2';
import { backendDateFormat, displayDateFormatShort } from '../../../constants';
import { GoogleLocationField } from '../../Elements';
import { trackActivity } from '../../../utils/mixpanel';
import { DeletePopUp } from '../../../shared_elements';


function EngineInspectionInfoV2({ data, onFieldChange, callthisapi, basicDropdown, setData, getResponseBack, usersList, currentFormDetail, setLoading, formSave, setFormSave, errors, setErrors }) {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [deleteModal, setDeleteModal] = useState({ modal: false, data: null })
    const keyAttendDisable = data?.key_attendees ? data?.key_attendees?.filter(item => item?.id)?.length === data?.key_attendees?.length : []
    const shouldShowError = Object.values(errors).every(
        (errorObj) => !errorObj?.email
    );
    const keyAttendee = (modeTye, row, extra) => {
        if (modeTye === 'add') {
            setData(prev => ({
                ...prev,
                key_attendees: [...(prev.key_attendees || []), { name: null, email: null, position: null, delteId: Math.floor(Math.random() * 90) + 10 }]
            }));
        } else if (row?.id) {
            setLoading(true)
            globalDeleteService(`/technical/t015/basic-inspection/${row?.id}/delete/?module=key_attendees`)
                .then(response => {
                    if (checkApiStatus(response)) {
                        getResponseBack()
                        setLoading(false)
                        setDeleteModal({ modal: false, data: null })
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Project Management', {
                            event_type: 'Key Attendee Delete',
                            page_title: 'T015 Form',
                            deleted_id: row?.id || '',
                            success_msg: response?.data?.message
                        });
                    } else {
                        getResponseBack()
                        setDeleteModal({ modal: false, data: null })
                        setLoading(false)
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Project Management', {
                            event_type: 'Key Attendee Delete',
                            page_title: 'T015 Form',
                            deleted_id: row?.id || '',
                            success_msg: response?.data?.message
                        });
                    }
                });
        } else {
            setData(prev => ({ ...(prev), key_attendees: [...data?.key_attendees]?.filter(item => item?.delteId !== extra?.delteId) }));
        }
    }

    return (
        <section className='form-t015' style={{ marginTop: '112px' }}>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4>1. Engine & Inspection Information : </h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {!(formSave?.type === 'engine_info' && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'engine_info',isdisabled:true})} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {formSave?.type === 'engine_info' && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack(); setFormSave({ open: false, type: '',isdisabled:false }); }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '',isdisabled:false }); }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>
                <Table className='mui-table-format-t015' >
                    <TableBody>
                        <TableRow>
                            <TableCell><h6>ESN</h6></TableCell>
                            <TableCell >
                                <TextField
                                    variant='outlined'
                                    margin='normal'
                                    id='serial_number'
                                    placeholder="Enter.."
                                    fullWidth
                                    disabled
                                    value={currentFormDetail?.asset?.asset_type === 1 ? currentFormDetail?.asset?.msn : currentFormDetail?.asset?.esn}
                                />
                            </TableCell>
                            <TableCell><h6>Lessee</h6> </TableCell>
                            <TableCell>
                                <Autocomplete
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    options={basicDropdown?.lessee || []}
                                    getOptionLabel={option => option}
                                    id="lessee_id"
                                    value={data?.lessee_id || null}
                                    onChange={(e, value) => onFieldChange(e, 'lessee_id', value)}
                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                />
                            </TableCell>
                            <TableCell><h6>Operator</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    variant='outlined'
                                    margin='normal'
                                    id='operator_id'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.operator_id || ''}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'operator_id', e.target.value) }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Model</h6></TableCell>
                            <TableCell>
                                <TextField
                                    variant='outlined'
                                    placeholder='Select...'
                                    margin="normal"
                                    fullWidth
                                    disabled
                                    id="model_id"
                                    value={currentFormDetail?.asset?.asset_type === 1 ? currentFormDetail?.asset?.aircraft_type : currentFormDetail?.asset?.engine_type}
                                />
                            </TableCell>
                            <TableCell><h6>Leased TR</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    variant='outlined'
                                    id='leased_tr'
                                    margin='normal'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.leased_tr || ''}
                                    onChange={(e) => onFieldChange(e, 'leased_tr', e.target.value ? e.target.value : null)}
                                />
                            </TableCell>
                            <TableCell><h6>Current TR</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    variant='outlined'
                                    margin='normal'
                                    id='current_tr'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.current_tr || ''}
                                    onChange={(e) => onFieldChange(e, 'current_tr', e.target.value ? e.target.value : null)}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Stand</h6></TableCell>
                            <TableCell>
                                <Autocomplete
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    options={['YES', 'NO', 'N/A']}
                                    getOptionLabel={option => option}
                                    id="is_on_stand"
                                    value={['YES', 'NO', 'N/A'].filter(item => item === data?.is_on_stand)[0] || null}
                                    onChange={(e, value) => onFieldChange(e, 'is_on_stand', value)}
                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                />
                            </TableCell>
                            <TableCell><h6>QEC Kit</h6></TableCell>
                            <TableCell>
                                <Autocomplete
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    options={[{ id: false, name: "NO" }, { id: true, name: "YES" }]}
                                    getOptionLabel={option => option?.name}
                                    id="has_qec_kit"
                                    value={[{ id: false, name: "NO" }, { id: true, name: "YES" }].filter((item => item?.id == data?.has_qec_kit))[0] || ''}
                                    onChange={(e, value) => onFieldChange(e, 'has_qec_kit', value?.id)}
                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                />
                            </TableCell>
                            <TableCell><h6>QEC Specification</h6></TableCell>
                            <TableCell>
                               <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    variant='outlined'
                                    margin='normal'
                                    id='has_qec_specification'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.has_qec_specification || ''}
                                    onChange={(e) => onFieldChange(e, 'has_qec_specification', e.target.value ? e.target.value : null)}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Engine Owner</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_info'}
                                    variant='outlined'
                                    margin='normal'
                                    id='engine_owner'
                                    placeholder="Enter.."
                                    fullWidth
                                    inputProps={{ maxLength: 50 }}
                                    value={data?.engine_owner || ''}
                                    onChange={(e) => onFieldChange(e, 'engine_owner', e.target.value ? e.target.value : null)}
                                />
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'><h4> Inspection General Information :</h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {shouldShowError !== false && !(formSave?.type === 'engine_inspection' && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'engine_inspection',isdisabled:true })} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {formSave?.type === 'engine_inspection' && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack(); setFormSave({ open: false, type: '',isdisabled:false }); setErrors({}) }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data);setFormSave({ open: false, type: '',isdisabled:false });  }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>
                <Table className='mui-table-format-t015' >
                    <TableBody >
                        <TableRow>
                            <TableCell><h6>SAEL Inspector</h6></TableCell>
                            <TableCell >
                                <Autocomplete
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_inspection'}
                                    options={usersList || []}
                                    getOptionLabel={option => option?.name}
                                    id="sael_inspector_id"
                                    value={data?.sael_inspector_id || null}
                                    onChange={(e, value) => onFieldChange(e, 'sael_inspector_id', value)}
                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                />
                            </TableCell>
                            <TableCell><h6>Inspection Location</h6></TableCell>
                            <TableCell width={400}>
                                <GoogleLocationField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_inspection'}
                                    location={data?.inspection_location ? data?.inspection_location : ''}
                                    onFieldChange={onFieldChange}
                                    formkey='inspection_location'
                                    label={null}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6>Inspection Date</h6></TableCell>
                            <TableCell>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_inspection'}
                                        margin="normal"
                                        id="inspection_date"
                                        format={displayDateFormatShort}
                                        fullWidth
                                        // disableFuture
                                        InputLabelProps={{ shrink: true }}
                                        value={data?.inspection_date ? data?.inspection_date : null}
                                        onChange={(date) => onFieldChange('', 'inspection_date', date ? moment(date).format(backendDateFormat) : null)}
                                        inputVariant='outlined'
                                    />
                                </MuiPickersUtilsProvider>
                            </TableCell>
                            <TableCell><h6>Physical Review</h6></TableCell>
                            <TableCell >
                                <Autocomplete
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_inspection'}
                                    options={[{ id: false, name: "NO" }, { id: true, name: "YES" }]}
                                    getOptionLabel={option => option?.name}
                                    id="has_physical_review"
                                    value={[{ id: false, name: "NO" }, { id: true, name: "YES" }].filter((item => item?.id == data?.has_physical_review))[0] || null}
                                    onChange={(e, value) => onFieldChange(e, 'has_physical_review', value?.id)}
                                    renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <ul className='list-inline' >
                    <li className="list-inline-item">
                        <h5 style={{ margin: '10px 0px 10px' }}> 1.1 Key Attendees from Lessee / Operator :</h5>
                    </li>
                    <li className="list-inline-item" style={{ float: 'right' }}>
                        <Button disabled={formSave?.type !== 'engine_inspection' || !onCheckFormPermission(currentFormDetail)} color="primary" variant="contained" size="small" style={{ margin: '5px' }} onClick={() => keyAttendee("add")}>+ ADD</Button>
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableHead className='table-align-head'>
                        <TableRow>
                            <TableCell><h6>Name</h6></TableCell>
                            <TableCell><h6>Email</h6></TableCell>
                            <TableCell><h6>Phone</h6></TableCell>
                            <TableCell><h6>Position</h6></TableCell>
                            <TableCell><h6>Action</h6></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.key_attendees?.length > 0 && data?.key_attendees?.map((row, index) => (
                            <TableRow key={row}>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_inspection'}
                                        variant='outlined'
                                        margin='normal'
                                        id='name'
                                        placeholder="Enter.."
                                        fullWidth
                                        inputProps={{ maxLength: 50 }}
                                        value={row?.name || ''}
                                        onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'name', e.target.value, 'key_attendees', index) }}
                                    />
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_inspection'}
                                        variant='outlined'
                                        fullWidth
                                        margin='normal'
                                        id='email'
                                        inputProps={{ maxLength: 50 }}
                                        placeholder="Enter.."
                                        value={row?.email || ''}
                                        onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'email', e.target.value, 'key_attendees', index) }}
                                    />
                                    {errors[index]?.email?.trim()?.length ? <span style={{ color: 'red', fontSize: '12px' }}>
                                        {errors[index]?.email}
                                    </span> : null}

                                </TableCell>
                                   <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_inspection'}
                                        variant='outlined'
                                        fullWidth
                                        margin='normal'
                                        id='phone'
                                        inputProps={{ maxLength: 50 }}
                                        placeholder="Enter.."
                                        value={row?.phone || ""}
                                        onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'phone', e.target.value, 'key_attendees', index) }}
                                    />
                                    {errors[index]?.phone?.trim()?.length ? <span style={{ color: 'red', fontSize: '12px' }}>
                                        {errors[index]?.phone}
                                    </span> : null}
                                </TableCell>
                                <TableCell style={{ textAlignLast: 'center' }}>
                                    <TextField
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'engine_inspection'}
                                        variant='outlined'
                                        fullWidth
                                        margin='normal'
                                        id='position'
                                        inputProps={{ maxLength: 50 }}
                                        placeholder="Enter.."
                                        value={row?.position || ""}
                                        onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'position', e.target.value, 'key_attendees', index) }}
                                    />
                                </TableCell>
                                <TableCell align='center'>
                                        <Tooltip title='Delete' arrow>
                                    <IconButton disabled={formSave?.type !== 'engine_inspection' || !onCheckFormPermission(currentFormDetail)} color='secondary'>
                                        <DeleteOutlinedIcon onClick={() => { row?.id ? setDeleteModal({ modal: true, data: row }) : keyAttendee('', '', row) }} />
                                    </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
            <Paper square style={{ padding: '10px', marginBottom: "5px" }} elevation={8}>
                <ul className='list-inline'>
                    <li className='list-inline-item'> <h4> 1.2 GTA & AELA Key Information & Checklist :</h4></li>
                    <li className='list-inline-item' style={{ float: 'right' }}>
                        {!(formSave?.type === 'lease_gta' && formSave?.open) && (
                            <Tooltip title="Edit" placement="top">
                                <IconButton disabled={!onCheckFormPermission(currentFormDetail) || formSave?.isdisabled} style={{ cursor: 'pointer' }} color="primary" size="small" onClick={() => setFormSave({ open: true, type: 'lease_gta',isdisabled:true })} > <EditIcon /> </IconButton>
                            </Tooltip>
                        )}
                        {formSave?.type === 'lease_gta' && (
                            <>
                                <Tooltip title="Cancel" placement="top">
                                    <Button style={{ marginInline: '5px' }} variant="outlined" color="primary" onClick={() => { getResponseBack(); setFormSave({ open: false, type: '',isdisabled:false }); }} size="small" > Cancel </Button>
                                </Tooltip>
                                <Tooltip title="Save" placement="top">
                                    <Button variant="contained" color="primary" onClick={() => { callthisapi('', data); setFormSave({ open: false, type: '',isdisabled:false }); }} size="small" > Save </Button>
                                </Tooltip>
                            </>
                        )}
                    </li>
                </ul>
                <Table className='mui-table-format-t015'>
                    <TableBody>
                        <TableRow>
                            <TableCell><h6 style={{ paddingLeft: "10px" }}>Lease Start Date</h6></TableCell>
                            <TableCell>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                        margin="normal"
                                        id="lease_start_date"
                                        format={displayDateFormatShort}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={data?.lease_conditions?.lease_start_date ? data?.lease_conditions?.lease_start_date : null}
                                        onChange={(date) => onFieldChange('', 'lease_start_date', date ? moment(date).format(backendDateFormat) : null, 'lease_conditions', '', 'date')}
                                        inputVariant='outlined'
                                    />
                                </MuiPickersUtilsProvider>
                            </TableCell>
                            <TableCell><h6 style={{ paddingLeft: "10px" }}>Lease End Date</h6></TableCell>
                            <TableCell>
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                        margin="normal"
                                        id="lease_end_date"
                                        format={displayDateFormatShort}
                                        fullWidth
                                        // disableFuture
                                        InputLabelProps={{ shrink: true }}
                                        value={data?.lease_conditions?.lease_end_date ? data?.lease_conditions?.lease_end_date : null}
                                        onChange={(date) => onFieldChange('', 'lease_end_date', date ? moment(date).format(backendDateFormat) : null, 'lease_conditions', '', 'date')}
                                        inputVariant='outlined'
                                    />
                                </MuiPickersUtilsProvider>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6 style={{ paddingLeft: "10px" }}>Redelivery Location</h6></TableCell>
                            <TableCell width={340}>
                                <GoogleLocationField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    location={data?.lease_conditions?.redelivery_location ? data?.lease_conditions?.redelivery_location : ''}
                                    onFieldChange={onFieldChange}
                                    extraParams='lease_conditions'
                                    // callFormApi={() => callthisapi('', data?.lease_conditions?.redelivery_location)}
                                    formkey='redelivery_location'
                                // onFocus={(e) => setInitialValue(e.target.value)}
                                    label={null}
                                />
                            </TableCell>
                            <TableCell ><h6 style={{ paddingLeft: "10px" }}>Redelivery Conditions/Checks</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    variant='outlined'
                                    fullWidth
                                    margin='normal'
                                    id='redelivery_checks'
                                    placeholder="Enter.."
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.lease_conditions?.redelivery_checks ? data?.lease_conditions?.redelivery_checks : null}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'redelivery_checks', e.target.value, 'lease_conditions') }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6 style={{ paddingLeft: "10px" }}>PMA Parts / DER Repairs Allowed</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    variant='outlined'
                                    fullWidth
                                    margin='normal'
                                    id='pma_parts_der_repairs_allowed'
                                    placeholder="Enter.."
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.lease_conditions?.pma_parts_der_repairs_allowed ? data?.lease_conditions?.pma_parts_der_repairs_allowed : null}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'pma_parts_der_repairs_allowed', e.target.value, 'lease_conditions') }}
                                />
                            </TableCell>
                            <TableCell ><h6 style={{ paddingLeft: "10px" }}>Maintenance Reserves / Compensation</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    variant='outlined'
                                    fullWidth
                                    margin='normal'
                                    id='reserves_payable_comp_terms'
                                    placeholder="Enter.."
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.lease_conditions?.reserves_payable_comp_terms ? data?.lease_conditions?.reserves_payable_comp_terms : null}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'reserves_payable_comp_terms', e.target.value, 'lease_conditions') }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6 style={{ paddingLeft: "10px" }}>Definition Qualifying SV</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    variant='outlined'
                                    fullWidth
                                    margin='normal'
                                    id='definition_of_hsv'
                                    placeholder="Enter.."
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.lease_conditions?.definition_of_hsv ? data?.lease_conditions?.definition_of_hsv : null}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'definition_of_hsv', e.target.value, 'lease_conditions') }}
                                />
                            </TableCell>
                            <TableCell ><h6 style={{ paddingLeft: "10px" }}>Redelivery ARC Requirements</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    variant='outlined'
                                    fullWidth
                                    margin='normal'
                                    id='redelivery_arc_requirements'
                                    placeholder="Enter.."
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.lease_conditions?.redelivery_arc_requirements ? data?.lease_conditions?.redelivery_arc_requirements : null}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'redelivery_arc_requirements', e.target.value, 'lease_conditions') }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell ><h6 style={{ paddingLeft: "10px" }}>Minimum FH Return Condition</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    variant='outlined'
                                    fullWidth
                                    margin='normal'
                                    id='minimum_hourly_return_condition'
                                    placeholder="Enter.."
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.lease_conditions?.minimum_hourly_return_condition ? data?.lease_conditions?.minimum_hourly_return_condition : null}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'minimum_hourly_return_condition', e.target.value, 'lease_conditions') }}
                                />
                            </TableCell>
                            <TableCell ><h6 style={{ paddingLeft: "10px" }}>Minimum FC Return Condition</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    variant='outlined'
                                    fullWidth
                                    margin='normal'
                                    id='minimum_cycle_return_condition'
                                    placeholder="Enter.."
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.lease_conditions?.minimum_cycle_return_condition ? data?.lease_conditions?.minimum_cycle_return_condition : null}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'minimum_cycle_return_condition', e.target.value, 'lease_conditions') }}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell><h6 style={{ paddingLeft: "10px" }}>Other Return Conditions</h6></TableCell>
                            <TableCell>
                                <TextField
                                    disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                    variant='outlined'
                                    fullWidth
                                    margin='normal'
                                    id='lease_conditions'
                                    placeholder="Enter.."
                                    inputProps={{ maxLength: 250 }}
                                    value={data?.lease_conditions?.minimum_return_condition_other ? data?.lease_conditions?.minimum_return_condition_other : null}
                                    onChange={(e) => { e.preventDefault(); e.stopPropagation(); onFieldChange(e, 'minimum_return_condition_other', e.target.value, 'lease_conditions') }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <Table className='mui-table-format-t015' style={{ margin: "15px 0px 5px" }}>
                     <ul className='list-inline'>
                    <li className='list-inline-item'> <h4> 1.3 General Lessee review :</h4></li>
                </ul>
                    <TableBody>
                        {gtalable_dropdownField?.map((item, index) => (
                            <TableRow>
                                <TableCell width='310' >
                                    <TextField
                                        disabled
                                        variant='outlined'
                                        margin='normal'
                                        fullWidth
                                        id='lessee_id'
                                        placeholder="Enter.."
                                        value={data?.lessee_id || ''}
                                    />
                                </TableCell>
                                <TableCell ><h6 style={{ paddingLeft: "10px" }}>{item?.lable}</h6></TableCell>
                                  <TableCell width='190' >
                                    <Autocomplete
                                        disabled={!onCheckFormPermission(currentFormDetail) || formSave?.type !== 'lease_gta'}
                                        options={item?.dropdown || []}
                                        getOptionLabel={option => option}
                                        id="lease_gta_condition_para"
                                        value={data?.lease_gta_condition_para && data?.lease_gta_condition_para[item?.value] || null}
                                        onChange={(e, value) => onFieldChange(e, item?.value, value, 'lease_gta_condition_para')}
                                        renderInput={params => <TextField variant='outlined' {...params} placeholder='Select...' margin="normal" fullWidth />}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
            {deleteModal?.modal ?
                <DeletePopUp
                    modal={deleteModal.modal}
                    toggleModalFn={() => setDeleteModal({ modal: false, data: null })}
                    title="Key Attendees from Lessee / Operator"
                    content={<h4>Are you sure you want to delete?</h4>}
                    deleteRecordFn={() => keyAttendee('', deleteModal?.data)}
                /> : null
            }
        </section>
    );
}

export default withRouter(EngineInspectionInfoV2)
